import { RouteRecordRaw } from '@vue-router';
import { configureRoutesMeta } from '@core/utils/configureRoutesMeta'
import { routes as authRoutes } from '~/router/unauthorizedRoutes/auth';
const routes: Array<RouteRecordRaw> = [
    ...authRoutes
];

export const unauthorizedRoutes = configureRoutesMeta(routes, true, 'AuthLayout');
